import React, { SetStateAction } from 'react'
import { Col, ProfileLocation, Row } from 'react-angle-dashboard-components'
import { useFacilityProfile } from './context'
import { LayoutContainer } from './style'

export interface IFacilityLocationSectionProps {
  selectedLocationIndex: number
  setSelectedLocationIndex: React.Dispatch<SetStateAction<number>>
}

export const FacilityLocationSection: React.FC<IFacilityLocationSectionProps> =
  ({ selectedLocationIndex, setSelectedLocationIndex }) => {
    const { googleApiKey } = (window as any).runtimeConfig
    const { mapLocations } = useFacilityProfile()

    return (
      <section className="pt-4 container-fluid">
        <LayoutContainer>
          <strong>Facility Location</strong>
          <Row className="my-3">
            <Col md="8">
              <ProfileLocation
                zoom={15}
                apiKey={googleApiKey}
                selectedLocationIndex={selectedLocationIndex}
                setSelectedLocationIndex={setSelectedLocationIndex}
                locations={mapLocations}
              />
            </Col>
          </Row>
        </LayoutContainer>
      </section>
    )
  }
